import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
const Button = ({
  id,
  type,
  children,
  className,
  small,
  primary,
  secondary,
  disabled,
  large,
  clickHandler,
  outlinedPrimary,
  outlinedSecondary,
  outlinedDark,
  light,
  block,
  regular,
  extraLight,
  danger,
  success,
}) => {
  return (
    <button
      id={id}
      type={type}
      className={cx(
        'btn',
        { 'btn--primary': primary },
        { 'btn--secondary': secondary },
        { 'btn--danger': danger },
        { 'btn--success': success },
        { 'btn--grey': light },
        { 'btn--small': small },
        { 'btn--regular': regular },
        { 'btn--large': large },
        { 'btn--block': block },
        { 'btn--outlined-primary': outlinedPrimary },
        { 'btn--outlined-secondary': outlinedSecondary },
        { 'btn--outlined-dark': outlinedDark },
        { 'btn--light': extraLight },
        className
      )}
      onClick={clickHandler}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  small: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  clickHandler: PropTypes.func,
  children: PropTypes.any,
  outlinedPrimary: PropTypes.bool,
  outlinedSecondary: PropTypes.bool,
  outlinedDark: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  light: PropTypes.bool,
  block: PropTypes.bool,
  regular: PropTypes.bool,
  danger: PropTypes.bool,
  extraLight: PropTypes.bool,
  success: PropTypes.bool,
};

Button.defaultProps = {
  id: '',
  className: '',
  small: false,
  primary: false,
  secondary: false,
  disabled: false,
  large: false,
  clickHandler: () => {},
  outlinedPrimary: false,
  outlinedSecondary: false,
  outlinedDark: false,
  type: 'button',
  light: false,
  block: false,
  regular: true,
  danger: false,
  extraLight: false,
  success: false,
};
export default Button;
